import axiosClient from "api/axiosClient"
import API_MAP from "constants/api"

export const userService = {
    getUserByEmail: async (email) => {
        try {
            const res = await axiosClient.get(`${API_MAP.USERS.GET_USER_BY_EMAIL}${email}`)

            if(res?.code === 0) return res?.data
        } catch (error) {
            console.log(error)
        }
    }
}